<div class="modal-header">
  <h3>Edit User Details</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>
<div class="modal-body">
  @if (userForm) {
    <form [formGroup]="userForm">
      <div class="row g-3">
        <div class="col-4">
          <div class="form-group">
            <label for="firstName" class="form-label" requiredAsterisk
              >First Name</label
            >
            <input
              id="firstName"
              type="text"
              class="form-control"
              formControlName="firstName"
            />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="lastName" class="form-label" requiredAsterisk
              >Last Name</label
            >
            <input
              id="lastName"
              type="text"
              class="form-control"
              formControlName="lastName"
            />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="jobTitle" class="form-label" requiredAsterisk
              >Job Title</label
            >
            <input
              id="jobTitle"
              type="text"
              class="form-control"
              formControlName="jobTitle"
            />
          </div>
        </div>
        <div class="col-4">
          <div class="form-group">
            <label for="jobTitle" class="form-label" requiredAsterisk
              >Permission</label
            >
            <select
              id="jobTitle"
              class="form-select"
              formControlName="UserAccountRoleId"
            >
              <option [ngValue]="null" selected disabled>Pick one...</option>
              @for (role of userAccountRoles; track role) {
                <option [ngValue]="role.id">
                  {{ role.displayName }}
                </option>
              }
            </select>
          </div>
        </div>
        @if (userForm.controls.Contact) {
          <ng-container [formGroup]="userForm.controls.Contact">
            <div class="col-4">
              <div class="form-group">
                <label for="email" class="form-label" requiredAsterisk
                  >Email</label
                >
                <input
                  id="email"
                  type="text"
                  class="form-control"
                  formControlName="email"
                />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="phone1" class="form-label" requiredAsterisk
                  >Phone</label
                >
                <input
                  id="phone1"
                  type="tel"
                  class="form-control"
                  placeholder="(___)___-____"
                  [inputMask]="phoneMask"
                  formControlName="phone1"
                />
              </div>
            </div>
          </ng-container>
        }
      </div>
      @if (userForm.controls.Contact.controls.StreetAddress) {
        <div
          [formGroup]="userForm.controls.Contact.controls.StreetAddress"
          class="row g-3"
        >
          <app-address-form
            [addressForm]="userForm.controls.Contact.controls.StreetAddress"
            [isStreet]="true"
            [country]="$safeNavigationMigration(Company?.country)"
          ></app-address-form>
        </div>
      }
    </form>
  }
</div>
<div class="modal-footer">
  <div class="row w-100 justify-content-end">
    <div class="col-3">
      <button class="btn btn-danger" (click)="close()">Close</button>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="save()">Save</button>
    </div>
  </div>
</div>
